import React from 'react';

const UploadProgress = ({ progress, statusText }) => {
  const radius = 34;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;
  const isConverting = statusText === 'converting';

  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-ag-black-900 bg-opacity-90 rounded-md">
      <div className="relative inline-flex items-center justify-center">
        <svg
          className={`transform -rotate-90 ${isConverting ? 'animate-spin-slow' : ''}`}
          width={80}
          height={80}
        >
          {/* Background circle */}
          <circle
            className="text-ag-black-600"
            strokeWidth={6}
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx={40}
            cy={40}
          />
          {/* Progress circle */}
          <circle
            className="text-ag-green transition-all duration-300 ease-in-out"
            strokeWidth={6}
            strokeDasharray={circumference}
            strokeDashoffset={isConverting ? circumference * 0.25 : offset}
            strokeLinecap="round"
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx={40}
            cy={40}
          />
        </svg>
        {/* Progress percentage or converting icon */}
        <div className="absolute">
          {isConverting ? (
            <span className="text-sm font-semibold text-ag-green">⟳</span>
          ) : (
            <span className="text-xl font-semibold text-white">{Math.round(progress)}%</span>
          )}
        </div>
      </div>
      {/* Status text below the circle */}
      {isConverting && (
        <p className="mt-2 text-xs text-ag-black-300 font-medium animate-pulse">Converting video…</p>
      )}
    </div>
  );
};

export default UploadProgress;